//here the i18n translation must be applied over the title
export const _init_notifications = [
	{
		title: 'collapse_title_phone_notification',
		props: {
			id: 'push_notification',
			values: [
				{ msg_type: 'push', i18n: 'type_push' },
				{ msg_type: 'alarm', i18n: 'type_alarm' },
			],
			msg: true,
			icon: 'fal fa-mobile-signal-out',
		},
	},
	{
		title: 'collapse_title_email_notification',
		props: {
			id: 'mail_notification',
			values: [{ msg_type: 'email', i18n: 'collapse_title_email_notification' }],
			msg: true,
			icon: 'fal fa-envelope',
		},
	},
	{
		title: 'collapse_title_add_event_log',
		props: {
			id: 'event_log',
			values: [{ msg_type: 'event_log', i18n: 'collapse_title_add_event_log' }],
			icon: 'fal fa-notebook',
			// msg: true
		},
	},
	{
		title: 'collapse_title_alexa_notify',
		props: {
			id: 'alexa_notif',
			values: [{ msg_type: 'alexa_notif', i18n: 'collapse_title_alexa_notify' }],
			icon: 'fa-brands fa-amazon',
			// msg: true
		},
	},
];
